// extracted by mini-css-extract-plugin
module.exports = {"skeleton_loader":"SkeletonLoader_skeleton_loader__BSy4Q","shine":"SkeletonLoader_shine__3Ybvo"};